import { useMutation } from 'react-query';

import { updateIdentityPortalPassword } from '../../lib/api';

export function useMutateUpdateIdentityPortalPassword() {
  return useMutation(updateIdentityPortalPassword);
}
